import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Notification } from 'react-iconly';
import { useNotifications } from '../hooks/useNotifications';

const COLORS = {
  PRIMARY_BROWN: '#8B4513',
  NEUTRAL_WHITE: '#FFFFFF',
  ERROR_RED: '#EF4444',
  ACCENT_GRAY: '#6B7280',
  BORDER_GRAY: '#E5E7EB',
  NEUTRAL_BG: '#F9FAFB',
  NEUTRAL_TEXT: '#222'
};

const FONTS = {
  body: { fontFamily: 'Inter, system-ui, sans-serif' },
  heading: { fontFamily: 'Inter, system-ui, sans-serif', fontWeight: 600 }
};

export default function NotificationBell() {
  const navigate = useNavigate();
  const { unreadCount } = useNotifications();

  const handleClick = () => {
    navigate('/seller-hub/notifications');
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={handleClick}
        style={{
          background: 'rgba(255,255,255,0.9)',
          border: 'none',
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          position: 'relative',
          transition: 'background-color 0.2s ease',
          ...FONTS.body
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,1)'}
        onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.9)'}
        aria-label={`Notifications (${unreadCount} unread)`}
      >
        <Notification set="regular" size={20} primaryColor={COLORS.NEUTRAL_TEXT} />
        
        {/* Unread badge */}
        {unreadCount > 0 && (
          <div style={{
            position: 'absolute',
            top: '4px',
            right: '4px',
            background: COLORS.ERROR_RED,
            color: COLORS.NEUTRAL_WHITE,
            borderRadius: '10px',
            minWidth: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 600,
            padding: '0 6px',
            ...FONTS.body
          }}>
            {unreadCount > 99 ? '99+' : unreadCount}
          </div>
        )}
      </button>
    </div>
  );
}
